import { render, staticRenderFns } from "./MultipleImage.vue?vue&type=template&id=1287ff2d&scoped=true&"
import script from "./MultipleImage.vue?vue&type=script&lang=js&"
export * from "./MultipleImage.vue?vue&type=script&lang=js&"
import style0 from "./MultipleImage.vue?vue&type=style&index=0&id=1287ff2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1287ff2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1287ff2d')) {
      api.createRecord('1287ff2d', component.options)
    } else {
      api.reload('1287ff2d', component.options)
    }
    module.hot.accept("./MultipleImage.vue?vue&type=template&id=1287ff2d&scoped=true&", function () {
      api.rerender('1287ff2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Upload/MultipleImage.vue"
export default component.exports